import { useMemo } from "react";
import { useQuery } from "react-query";
import { referenceDataQueryKeys } from "../features/flightSchedule/ScheduleDraft/hooks/queryKeys";
import { scheduleDraftReferenceDataService } from "../features/flightSchedule/ScheduleDraft/services/scheduleDraftReferenceDataService";

const REFERENCE_STALE_TIME = 10 * 60 * 1000;
const REFERENCE_CACHE_TIME = 30 * 60 * 1000;

export const useAircrafts = (options = {}) => {
    const query = useQuery(referenceDataQueryKeys.aircrafts(), () => scheduleDraftReferenceDataService.getAircrafts(), {
        staleTime: REFERENCE_STALE_TIME,
        cacheTime: REFERENCE_CACHE_TIME,
        refetchOnWindowFocus: false,
        ...options,
    });

    const aircrafts = query.data || [];
    const aircraftMap = useMemo(
        () =>
            aircrafts.reduce((acc, aircraft) => {
                if (aircraft.registration) {
                    acc[aircraft.registration] = aircraft;
                }
                return acc;
            }, {}),
        [aircrafts],
    );

    return {
        aircrafts,
        aircraftMap,
        isLoading: query.isLoading,
        loading: query.isLoading,
        isFetching: query.isFetching,
        error: query.error,
        refetch: query.refetch,
    };
};

export default useAircrafts;
